module.exports = __webpack_public_path__ + "media/PAG71-05.808ea9fd.mp3";